export default {
    'Tutor': 'Учитель',
    'Lesson_booked': 'Урок забронирован',
    'Group': 'Группа',
    'Format': 'Формат',
    'Link_making_lesson': 'Ссылка на отработку',
    'Comment': 'Комментарий',
    'Phone': 'Телефон',
    'Close': 'Закрыть',
    'Cancel_your_booking': 'Отменить запись',
    'Making_lessons': 'Отработка уроков',
    'You_make_missed_classes': 'Список пропусков',
    'Select_free_time_slots': 'Для записи к Репетитору выберите свободные слоты времени и <br/> нажмите на кнопку “Запись на отработку”.',
    's_week': 'Укажите неделю',
    'Book_up_lesson': 'Записаться',
    'The_lesson_booked': 'Забронировано вами',
    'Lesson': 'Урок',
    'Booked': 'Забронировано',
    'worked': 'отработано',
    'Select_least_time': 'Вы должны выбрать хотя бы одну ячейку времени.',
    'Period_successfully_removed': 'Период успешно удалён.',
    'no_possibility_3_blank_spaces': 'Вы не можете выбрать больше 3-х слотов.',
    'no_possibility_3_classes_per_day': 'Вы не можете отработать более 3-х уроков за один день.',
    'no_more_classes_left': 'У вас нет больше уроков для отработки.',
    'Successfully': 'Успешно',
    'Date':'Дата',
    'Time':'Время',
    'Program':'Программа',
    'Save': 'Сохранить',
    'Book_making_lesson': 'Запись на отработку',
    'class_missed':'Пропущенное занятие',
    'offline_class':'В классе',
    'online_class':'Онлайн',
    'show_more': 'Показать еще',
    'messages': 'Уведомления',
    'groups_list': 'Выберите группу',
    'Good': 'Хорошо',
    'Days': 'Дни',
    'Hours': 'Часы',
    'Minutes': 'Минуты',
    'Seconds': 'Секунды',
    'Access to the lesson will be closed through:': 'Доступ к уроку закроется через:',
};
